<script>
import { defineComponent } from 'vue';
import CustomerSrv from '@/services/customer.service';
import moment from 'moment';

export default defineComponent({
    name: 'customerInvoiceItem',
    props: {
        inv: Object,
    },
	data() {
		return {
			invDetail: null,
			loadingDetail: false
		}
	},
    setup() {},
    methods: {
        onHide(evt) {
            this.invDetail = null;
        },
        calculateSubTotal(uom, qty, price) {

            if (uom == "MFT" || uom == "FT") {
                return new Intl.NumberFormat("en-EN", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format((parseInt(qty)/1000) * parseFloat(price))
            } 
            return new Intl.NumberFormat("en-EN", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(parseInt(qty) * parseFloat(price))
        },
		fetchInvDetail(evt) {
			this.loadingDetail = true;
			var self = this;
			CustomerSrv.GetInvoiceDetail(this.accessToken, evt.invoiceNumber).then((response) => {
				if (response.status==200) {
					self.invDetail = response.data;
					self.loadingDetail = false;
				}
			}).catch((e) => {
				self.$store.dispatch('message/sendMessage', {message: 'There was an error loading Invoice', position: 'bottom', icon: 'alert'}, {root:true});
			})
		}
    },
	computed: {
		accessToken() {
			return this.$store.getters['auth/accessToken'];
		},
		cashReceived() {
			return new Intl.NumberFormat("en-EN", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.inv.paidAmount);
		},
		netDue() {
			let x = this.inv.invoiceAmount-this.inv.paidAmount
			return new Intl.NumberFormat("en-EN", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(x);
		},
        age() {
			moment.suppressDeprecationWarnings = true;
			return parseInt(moment.duration(moment() - moment(this.inv.invoiceDate)).asDays());
        },
        hasOrderPermission() {
            return this.$store.getters['auth/hasOrderPermission'];
        }
	}
})
</script>

<template>
    <q-expansion-item expand-icon-class="wcwBlue expandIconWCW" @before-show="fetchInvDetail(inv)" @hide="onHide()">
        <template v-slot:header>
            <q-item-section>
            <div class="row">
                <div class="col-12">
                    <h3 style="line-height: 1.5em;">#{{inv.invoiceNumber}}</h3>
					<h3 style="line-height: 1.5em;">Ref: {{inv.customerReference}}</h3>
                    <span class="orderPrice">${{inv.invoiceAmount}}</span>
                </div>
            </div>
            </q-item-section>
            <q-item-section side>
            <div class="row items-center">
                <q-icon name="fal fa-calendar" color="cyan-7" size="18px" />
                <span class="q-pt-xs q-pl-sm text-cyan-7">{{inv.invoiceDate}}</span>
            </div>
            <span class="q-pt-xs q-pl-sm text-grey-10">{{inv.status}}</span>
            </q-item-section>
        </template>

        <template v-slot:default>
			<div class="bodyContainer consignmentProduct">
				<div class="invoiceInformation">
					<span class="inVoiceDate">Invoice Date:<span>{{inv.invoiceDate}}</span></span>
					<span class="invoiceReference">Reference:<span>{{inv.customerReference}}</span></span>
					<span class="invoiceAge">Age:<span>{{age}} Days</span></span>
					<span class="invoiceAmount">Amount:<span>${{inv.invoiceAmount}}</span></span>
					<span class="cashReceived">Cash Received:<span>${{cashReceived}}</span></span>
					<span class="netDue">Net Due:<span>${{netDue}}</span></span>
					<span class="invoiceStatus">Status:<span>{{inv.status}}</span></span>
				</div>
				<div v-if="invDetail != null">
					<div class="orderView" v-for="(item, idx) in invDetail" :key="idx">
						<div class="row q-pa-none">
							<div class="col-6">
								<h4 style="line-height: 1.5em;"><strong>{{item.itemNumber}}</strong></h4>
								<p class="orderProductDescription">{{item.description}}</p>
							</div>
							<div class="col-4">
								<span class="orderQuantity">Quantity:<span class="ml-1">{{parseInt(item.orderQty)}}</span></span>
								<span class="orderProductPrice">${{item.priceAlt}} {{item.priceCostUnit}}</span>
								<span class="orderSubTotal">Subtotal:<span>${{calculateSubTotal(item.priceCostUnit, parseInt(item.orderQty), item.priceAlt)}}</span></span>
							</div>
							<div class="col-2 text-right q-mt-sm">
								<q-btn flat size="md" :ripple=true :outlined=true color="cyan-7" icon="fas fa-cart-plus" @click="$store.dispatch('cart/addToCart', [this.accessToken, item.itemNumber, parseInt(item.orderQty)])"/>
							</div>
						</div>	
					</div>
				</div>

				<div class="invoiceInformationBottom">
					<div class="row">
						<div class="col text-center">
							<q-btn class="q-mt-sm" color="cyan-7" icon="fas fa-envelope" label="Email Invoice" :unelevated=true :ripple=true @click="$store.commit('customer/setEmailInvoice', inv)"/>
						</div>
					</div>
				</div>
				<q-inner-loading
					:showing="loadingDetail"
					label="Please wait loading data..."
					label-class="text-cyan-7"
					label-style="font-size: 1.5em"
					color="cyan-7"/>
			</div>

        </template>

    </q-expansion-item>
    <div class="mobileDiv"></div>
      
</template>

<style>
.expandIconWCW i{font-size: 45px !important; padding-right: 0px;}
</style>